<div class="row bg-light py-3">
  <div class="col-12 col-xl-6">
    <div class="d-flex">
      <app-catalog-graphic imageClasses="flex-shrink-0 border me-3 bg-white"
                           [imageSize]="50"
                           [imageId]="this.imageId"></app-catalog-graphic>
      <div class="flex-grow-1">
        <p class="mb-1">
          <strong>{{ vendorName }}</strong>
        </p>
        <app-purchase-title
          [product]="product"
          [offer]="offer">
        </app-purchase-title>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6 mt-3 align-self-center" *ngIf="licensesAvailable">
    <div class="row">
      <h3 class="col">License Files</h3>
    </div>

    <div>
      <div class="row text-break mt-1 mb-1" *ngFor="let dl of licenses">
        <div class="col">
          <app-download [download]="dl"></app-download>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6 mt-3 align-self-center" [ngClass]="{'offset-xl-6': licensesAvailable}"
       *ngIf="downloadsAvailable">
    <div class="row">
      <h3 class="col">Installation Files</h3>
    </div>

    <div>
      <div class="row text-break mt-1 mb-1" *ngFor="let dl of downloads">
        <div class="col">
          <app-download [download]="dl"></app-download>
        </div>
      </div>
    </div>
  </div>
</div>
